<template>
  <div class="animated fadeIn">
    <b-card class="no-border animated">
      <div class="item-header clearfix mb-3">
        <h5 v-if="isEdit" class="pull-left mb-0 mt-2">Edit Order: {{number}}</h5>
        <h5 v-if="!isEdit" class="pull-left mb-0 mt-2">Create New Order</h5>
      </div>
      <b-form @submit.prevent="onSubmit()">
        <div class="form-row create-edit-order__form">
          <legend>Company</legend>
          <div class="form-group col-md-6">
            <label>Company</label>
            <multiselect
                name="company"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('company')}"
                v-model="selectedCompany"
                :options="companiesData"
                label="name"
                track-by="id"
                :disabled="isAddFromSelectedShipment"
                placeholder="Select company" class="mb-4"/>
          </div>
          <div class="form-group col-md-6">
            <label>Customer</label>
            <multiselect
                name="customer"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('customer')}"
                v-model="selectedCustomer"
                :options="customersData"
                label="name"
                track-by="id"
                :disabled="isEdit"
                placeholder="Select customer" class="mb-4"/>
          </div>
          <legend>Destination</legend>
          <div class="form-group col-md-6">
            <label>Destination</label>
            <multiselect
                name="destination"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('destination')}"
                v-model="selectedDestination"
                :options="destinationList"
                label="name"
                track-by="id"
                :disabled="hasSelectedCustomer"
                placeholder="Select destination" class="mb-4"/>
          </div>
        </div>
        <div class="form-row create-edit-order__form">
          <legend>Detail Order</legend>
          <div class="form-group col-md-6">
            <label for="number_order">Order Number</label>
            <input
              type="text"
              name="order number"
              v-validate="'required'"
              :class="{'is-invalid': errors.has('order number')}"
              class="form-control"
              id="number_order"
              placeholder="Input number"
              v-model="form.number"
            >
            <b-form-feedback>{{ errors.first('order number') }}</b-form-feedback>
          </div>
          <div class="form-group col-md-6">
            <label for="shipment_id">Shipment Number</label>
            <multiselect
                v-model="selectedShipment"
                :options="shipments"
                label="name"
                track-by="id"
                :disabled="isAddFromSelectedShipment"
                placeholder="Select shipments" class="mb-4"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <legend>Units</legend>
            <b-card>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Number</label>
                  <input
                    v-model="currentUnitNumber"
                    class="form-control"
                    type="text"
                    name="unit-number"
                    placeholder="Unit Number">
                </div>
                <div class="form-group col-md-6">
                  <label>Type</label>
                  <input
                    v-model="currentUnitType"
                    class="form-control"
                    type="text"
                    name="unit-type"
                    placeholder="Unit Type">
                </div>
              </div>
              <b-button @click="addUnits()" variant="primary">Add</b-button>
              <hr>
              <div class="form-row">
                <div class="col-md-12">
                  <b-list-group flush>
                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                      href="#" v-for="(unit, idx) in form.units" :key="unit.number">
                      <div class="pull-left">
                        <span class="text-primary">{{unit.number}}</span>
                        -
                        <span class="text-muted ">{{unit.type}}</span>
                      </div>
                      <div class="pull-right">
                        <b-button
                          @click="removeUnit(idx)"
                          variant="outline-danger"
                          class="m-md-2"><i class="fa fa-trash-o fa-lg"></i></b-button>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <hr>
        <b-button type="submit" variant="primary">Save changes</b-button>
        <b-button
          @click="onCancel()"
          type="reset"
          variant="outline-secondary"
          class="pull-right">Cancel</b-button>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { filter, get, isEqual, isEmpty, uniqBy, concat, find } from 'lodash';

export default {
  components: {
    Multiselect,
  },
  name: 'order_edit',
  data() {
    return {
      companiesData: [],
      customersData: [],
      selectedCompany: null,
      selectedCustomer: null,
      selectedDestination: null,
      selectedShipment: null,
      destinationList: [],
      shipmentList: [],
      currentUnitNumber: '',
      currentUnitType: '',
      form: {
        id: null,
        number: '',
        customer: null,
        destination: null,
        company: null,
        invoice: '',
        shipment: '',
        units: [],
      },
    };
  },
  created() {
    const { orderId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'orders', name: 'Orders' },
      { to: orderId, name: 'Detail' },
      { to: 'edit', name: 'Edit' },
    ];

    if (!this.isEdit) {
      breadcrumb.splice(3, 2);
      breadcrumb.push({ to: 'create', name: 'Create' });
    }

    if (this.isEdit) {
      this.$store.commit('shipment_md/orders/SET_DETAIL_ID', orderId);
      this.$store.dispatch('shipment_md/orders/LOAD_DETAIL_DATA');
    }

    this.$store.commit('shipment_md/shipments/SET_QUERY_COUNT', 1e3);
    this.$store.dispatch('shipment_md/shipments/LOAD_DATA');
    this.$store.dispatch('shipment_md/orders/LOAD_LOCATIONS');
    this.loadCompaniesData();
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    locations() {
      return this.$store.getters['shipment_md/orders/get_locations_data'];
    },
    shipments() {
      const shipments = this.$store.getters['shipment_md/shipments/shipments'];
      return shipments.filter(s => s.state === 'CREATED');
    },
    userData() {
      return this.$store.getters.userData;
    },
    detailedInfo() {
      return this.$store.getters['shipment_md/orders/get_detail_data'];
    },
    number() {
      return this.detailedInfo.number;
    },
    isEdit() {
      return !isEmpty(this.$route.params.orderId);
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    selectedCompanyShipment() {
      const selected = this.$store.getters['shipment_md/orders/get_selected_value'];
      let { shipment } = selected;
      if (shipment) shipment = { ...this.addObjectKey(shipment, 'number', 'name') };
      return selected;
    },
    hasSelectedCustomer() {
      return !this.selectedCustomer || isEmpty(this.destinationList);
    },
    isAddFromSelectedShipment() {
      const { shipment } = this.selectedCompanyShipment;
      return !isEmpty(shipment);
    },
  },
  watch: {
    detailedInfo(data) {
      const { form } = this;
      form.id = data.id;
      form.number = data.number;
      form.invoice = data.invoice;
      form.units = data.units;
      this.selectedCustomer = data.customer;
      this.selectedDestination = data.destination;

      if (this.isEdit) {
        this.selectedCompany = data.company;
        this.selectedShipment = { ...this.addObjectKey(data.shipment, 'number', 'name') };
        form.units = data.units.map((unit) => {
          delete unit.id;
          return unit;
        });
      }
    },
    shipments(data) {
      const filtered = filter(data, { state: 'CREATED' });
      filtered.forEach((shipment) => { shipment.name = shipment.number; });
      this.shipmentList = [...filtered];
    },
    companiesData(data) {
      if (!this.isEdit && this.isAddFromSelectedShipment) {
        this.selectedCompany = this.selectedCompanyShipment.company;
        this.selectedShipment = this.selectedCompanyShipment.shipment;
      } else if (!this.isEdit && !this.isAddFromSelectedShipment) {
        const userCompanyId = this.userData.company_id;
        const userCompany = find(data, { id: userCompanyId.toString() });
        this.selectedCompany = userCompany;
      }
    },
    selectedCompany(data) {
      this.form.company = { ...data };
    },
    selectedCustomer(data) {
      const customerId = !data ? null : data.id;
      this.form.customer = { ...data };
      this.destinationList.splice(0);
      this.destinationList = filter(this.locations, { company: { id: customerId } });
      if (!isEqual(customerId, get(this.selectedDestination, 'company.id'))) {
        this.selectedDestination = [];
      }
    },
    selectedDestination(data) {
      this.form.destination = { ...data };
    },
    selectedShipment(data) {
      this.form.shipment = { ...data };
    },
  },
  methods: {
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          let { orderId } = this.$route.params;
          const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';

          if (this.isAddFromSelectedShipment) {
            this.form.company = this.selectedCompanyShipment.company;
            this.form.shipment = this.selectedCompanyShipment.shipment;
          }

          this.$store.dispatch(`shipment_md/orders/${action}`, this.form).then((order) => {
            orderId = this.isEdit ? orderId : order.id;
            if (this.isAddFromSelectedShipment) {
              const { id: shipmentId } = this.selectedCompanyShipment.shipment;
              this.$router.push(`/shipment_md/shipments/${shipmentId}/orders`);
            } else {
              this.$router.push(`/shipment_md/orders/${orderId}`);
            }
          });
        }
      });
    },
    addUnits() {
      if (this.currentUnitType === '' || this.currentUnitNumber === '') {
        return;
      }
      this.form.units.push({
        type: this.currentUnitType,
        number: this.currentUnitNumber,
      });
      this.currentUnitType = '';
      this.currentUnitNumber = '';
    },
    removeUnit(unitIndex) {
      this.form.units.splice(unitIndex, 1);
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      const { orderId } = this.$route.params;
      const { id: shipmentId } = this.selectedCompanyShipment.shipment || {};
      const route = this.isAddFromSelectedShipment ? `/shipment_md/shipments/${shipmentId}/orders` : '/shipment_md/orders';

      if (this.isEdit) {
        this.$router.push(`/shipment_md/orders/${orderId}`);
      } else {
        this.$router.push(route);
      }
    },
    addObjectKey(obj, keyValue, newKey) {
      if (!isEmpty(obj)) obj[newKey] = obj[keyValue];
      return obj;
    },
    loadCompaniesData() {
      return Promise.all([
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 0 }),
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 1 }),
      ]).then((data) => {
        const companies = data[0] || [];
        const customers = companies.filter(dt => dt.type === 'CUSTOMER');
        const tenants = data[1];
        this.companiesData = companies;
        this.customersData = !this.isSystemAdmin ? uniqBy(concat(customers, tenants), 'id') : companies;
      });
    },
  },
};
</script>
<style lang="sass">
@import "~vue-multiselect/dist/vue-multiselect.min"
.multiselect-danger .multiselect__tags
  border: 1px solid #f86c6b

.create-edit-order__form
  .multiselect
    z-index: 0
  .multiselect--active
    z-index: 9999
  .multiselect--active
    .multiselect__content-wrapper
      z-index: 9999 !important
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/orders/CreateEdit.vue